/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

/**
 * Derived from the dates on every read, never stored, so it cannot go stale. `openSoon` means simply "has not started yet" — there is no nearness threshold.
 */
export type TransferWindowDtoStatus = typeof TransferWindowDtoStatus[keyof typeof TransferWindowDtoStatus];


export const TransferWindowDtoStatus = {
  open: 'open',
  openSoon: 'openSoon',
  closed: 'closed',
} as const;
